import React, { useContext } from "react";
import Logo from "../assets/images/logo.png";
import { sidebarData } from "../hooks/helper";
import { Link } from "react-router-dom";
import useBreakPoints from "../hooks/useBreakPoints";
import { MyContext } from "../hooks/MyContextProvider";
const Sidebar = () => {
  const { isTablet } = useBreakPoints();
  const { open, setOpen } = useContext(MyContext);
  return (
    <div
      class="sidebar-wrapper"
      style={{ display: !open && isTablet && "none" }}
      data-layout="stroke-svg"
    >
      <div class="logo-wrapper">
        <Link to="/">
          <img class="img-fluid" src={Logo} height={60} width={60} alt="" />
        </Link>
        {isTablet && (
          <div
            style={{ cursor: "pointer" }}
            class="back-btn"
            onClick={() => {
              setOpen(!open);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-grid status_toggle middle sidebar-toggle"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </div>
        )}
        <div class="toggle-sidebar" checked="checked">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-grid status_toggle middle sidebar-toggle"
          >
            <rect x="3" y="3" width="7" height="7"></rect>
            <rect x="14" y="3" width="7" height="7"></rect>
            <rect x="14" y="14" width="7" height="7"></rect>
            <rect x="3" y="14" width="7" height="7"></rect>
          </svg>
        </div>
      </div>
      {/* <div class="logo-icon-wrapper">
        <a href="index.html">
          <img
            class="img-fluid"
            src="https://admin.pixelstrap.net/riho/assets/images/logo/logo-icon.png"
            alt=""
          />
        </a>
      </div> */}
      <nav class="sidebar-main">
        <div class="left-arrow disabled" id="left-arrow">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-arrow-left"
          >
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
        </div>
        <div id="sidebar-menu">
          <ul
            class="sidebar-links"
            id="simple-bar"
            data-simplebar="init"
            style={{ display: "block" }}
          >
            <div class="simplebar-wrapper" style={{ margin: 0 }}>
              <div class="simplebar-height-auto-observer-wrapper">
                <div class="simplebar-height-auto-observer"></div>
              </div>
              <div class="simplebar-mask">
                <div class="simplebar-offset" style={{ right: 0, bottom: 0 }}>
                  <div
                    class="simplebar-content-wrapper"
                    style={{ height: "100%", overflow: "hidden scroll" }}
                  >
                    <div class="simplebar-content mt-4" style={{ padding: 0 }}>
                      {sidebarData?.map((item, i) => {
                        return (
                          <>
                            <li key={i} class="sidebar-main-title">
                              <div>
                                <h6 class="lan-1">{item?.mainTitle}</h6>
                              </div>
                            </li>
                            {item?.menu?.length > 0 &&
                              item?.menu?.map((menuItem, j) => {
                                return (
                                  <li key={j} class="sidebar-list">
                                    <Link
                                      class="sidebar-link sidebar-title"
                                      to={menuItem?.link}
                                    >
                                      {menuItem?.icon}
                                      <span class="lan-3">
                                        {menuItem?.title}
                                      </span>
                                      {menuItem?.subMenu?.length > 0 && (
                                        <div class="according-menu">
                                          <i class="fa fa-angle-down"></i>
                                        </div>
                                      )}
                                    </Link>
                                    {/* <ul
                                      class="sidebar-submenu"
                                      style={{ display: "block" }}
                                    >
                                      <li>
                                        <a href="index.html" class="active">
                                          Default
                                        </a>
                                      </li>
                                      <li>
                                        <a href="dashboard-02.html">Ecommerce</a>
                                      </li>
                                      <li>
                                        <a href="dashboard-03.html">Project</a>
                                      </li>
                                    </ul> */}
                                  </li>
                                );
                              })}
                          </>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="simplebar-placeholder"
                style={{ width: "auto", height: 2154 }}
              ></div>
            </div>
            <div
              class="simplebar-track simplebar-horizontal"
              style={{ visibility: "hidden" }}
            >
              <div
                class="simplebar-scrollbar"
                style={{ width: 0, display: "none" }}
              ></div>
            </div>
            <div
              class="simplebar-track simplebar-vertical"
              style={{ visibility: "visible" }}
            >
              <div
                class="simplebar-scrollbar"
                style={{
                  height: "25px",
                  transform: "translate3d(0px, 0px, 0px)",
                  display: "block",
                }}
              ></div>
            </div>
          </ul>
          <div class="right-arrow" id="right-arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-arrow-right"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
